import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { UpdateField } from '@webapp/store/release/action-creators';
import { UPDATE_FIELD } from '@webapp/store/release/actions';
import AppState from '../../../state';

export const trackReleasePaidItems = (
  action$: Observable<UpdateField<'paidItems'>>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(UPDATE_FIELD),
    filter((action) => action.field === 'paidItems'),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (window.analytics) {
        const contact =
          state.artist.active?.email || state.artist.active?.telephone;
        const paidItems = action.value || [];
        window.analytics.track('One Time Payment', {
          client: {
            id: state.artist.active?.id,
            name: state.artist.active?.name,
            contact,
            plan: state.subscription.current?.plan,
          },
          oneTimePayments: paidItems.map((item) => {
            return {
              name: item.product.name,
              amount: item.price.value,
            };
          }),
          features: paidItems.map((o) => o.product.product_key),
          amount:
            paidItems.reduce(
              (memo, o) => memo + o.price.value * o.quantity,
              0
            ) / 100,
        });
      }
    }),
    filter(() => false)
  );
